<div class="offset-nonav center-content loginpage">

    <div class="container container-narrow">
        <div class="logoholder">
            <img src="../../images/BB-Link-logo.svg" class="img-responsive" />
            <div [hidden]="!isInitializing" class="status-text">
                <br />
                <p><img src="../../images/ajax-loader.gif" alt="Logging in" /> Initializing...</p>
            </div>
        </div>

        @if (!isCheckingRefreshToken && !isUnknownTenant) {
        <div>
            @if (isRequestingMFA) {
            <h2 class="text-center">Two-factor authentication</h2>
            <div class="mfa">
                <div class="mfa-box">
                    <form name="mfaForm" (submit)="verify()" [hidden]="isInitializing" #mfaForm="ngForm" novalidate>
                        <fieldset>
                            <div class="form-group">
                                <label class="mfa-label" for="totp">Authentication code<a (click)="mfaBack()">Back</a></label>
                                <input type="text" name="totp" #totpInput="ngModel" id="totp" value="" autocomplete="off" autofocus required [bizFocus]="true" class="form-control input-block"
                                    inputmode="numeric" pattern="[0-9]{6}" placeholder="6-digit code" [(ngModel)]="totp">
                                <button class="btn btn-primary btn-block" [disabled]="totpInput.invalid" type="submit">Verify</button>
                            </div>
                        </fieldset>
                    </form>
                </div>
                <div class="mfa-help">
                    <svg class="mfa-help-device" viewBox="0 0 10 16" version="1.1" width="10" height="16" aria-hidden="true">
                        <path fill-rule="evenodd"
                            d="M9 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM5 15.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zM9 12H1V2h8v10z">
                        </path>
                    </svg>
                    Open the two-factor authentication app on your device to view your authentication code
                    and verify your identity.
                </div>
            </div>
            }

            @if (!isRequestingMFA) {
            <form name="loginForm" (submit)="login()" [hidden]="isInitializing">
                <fieldset [disabled]="isAuthenticating">

                    @if (azureADSettings.LinkUserEnabled) {
                    <div class="form-group">
                        <label>Username</label>
                        <input class="form-control input-lg" autofocus type="text" [(ngModel)]="username" name="username" />
                    </div>

                    <div class="form-group">
                        <label>Password</label>
                        <input class="form-control input-lg" type="password" [(ngModel)]="password" name="password" />
                    </div>

                    <div style="display: grid; grid-template-columns: 1fr 1fr">
                        <div class="form-group control control-checkbox">
                            <label style="display: inline"><input type="checkbox" [(ngModel)]="rememberMe" name="rememberMe" /><i></i> Remember me</label>
                        </div>
                        <div class="form-group control control-checkbox" style="justify-self: right">
                            <a href="#" (click)="onResetPassword($event)">Reset password</a>
                        </div>
                    </div>

                    <div class="form-group">
                        <button type="submit" id="btnLogin" class="btn btn-primary btn-lg btn-block">Login</button>
                    </div>
                    }

                    @if (azureADSettings.AzureADUserEnabled) {
                    <div class="form-group">
                        @if (azureADSettings.LinkUserEnabled) {
                        <div class="RuleWithText Login-separator mt-xs-3">Or
                        </div>
                        }
                        <button type="button" class="login-button" [disabled]="isAuthenticating" (click)="openAzureLogin()">
                            <img src="/assets/ms-login.svg" />
                            <div></div>
                        </button>
                    </div>
                    }

                    @if (isAuthenticating) {
                    <p class="text-center">
                        <img src="../../images/ajax-loader.gif" /> Logging in...
                    </p>
                    }
                </fieldset>
            </form>
            }
        </div>
        }

        @if (isCheckingRefreshToken) {
        <div class="text-center">
            <h1>Checking login</h1>
            <p><img src="../../images/ajax-loader.gif" alt="Logging in" /></p>
        </div>
        }

        @if (isUnknownTenant) {
        <div class="text-center">
            <h1>Unapproved tenant</h1>
            <p>This user is not member of an Azure AD approved for use in Link. Please review your approved Azure AD tenants.</p>
            <button type="button" class="btn btn-primary btn-lg btn-block" (click)="onUnknownTenantOk()">Ok</button>
        </div>
        }

        <br class="xs-50" />
        <p class="text-center">&copy; {{ todaysDate.getFullYear() }} Bizbrains</p>
    </div>

    <dialog #resetDialog class="auth-dialog" (cancel)="onResetCancel($event)">
        <form #resetForm="ngForm" (ngSubmit)="onResetConfirm()">
            <div class="logoholder">
                <img src="../../images/BB-Link-logo.svg" class="img-responsive" />
            </div>

            <h2>Request a password reset</h2>

            <app-textbox [(ngModel)]="resetUsername" name="resetUsername" caption="Username" required></app-textbox>

            <div>
                <p class="auth-dialog__note">
                    If your username matches one of our accounts, we will send you an email with instructions on how to reset your password.
                </p>
                <p class="auth-dialog__note">
                    Note: Microsoft accounts cannot use this method.
                </p>
            </div>

            <div class="auth-dialog__actions">
                <app-button secondary width="100%" [disabled]="isResettingPassword" (buttonClick)="onResetCancel()">Cancel</app-button>
                <app-button primary width="100%" [submit]="true" [disabled]="resetForm.invalid || isResettingPassword">Request reset</app-button>
            </div>
        </form>
    </dialog>

    <dialog #confirmDialog class="auth-dialog" (cancel)="onConfirmClose($event)">
        <div class="logoholder">
            <img src="../../images/BB-Link-logo.svg" class="img-responsive" />
        </div>

        <h2>Check your email</h2>

        <div class="auth-dialog__icon">
            <svg viewBox="0 0 64 64" width="120" height="120">
                <rect x="8" y="16" width="48" height="32" rx="2" fill="#e8e8e8" stroke="#999" stroke-width="1.5" />
                <path d="M 8 18 L 32 34 L 56 18" fill="none" stroke="#999" stroke-width="1.5" stroke-linejoin="round" />
            </svg>
        </div>

        <p class="auth-dialog__message">We have sent you an email with instructions to reset your password.</p>

        <app-button tertiery class="auth-dialog__link" (buttonClick)="onDidNotGetEmail()">I did not get an email</app-button>

        <p class="auth-dialog__message">Please check your spam or junk folder.</p>

        <div class="auth-dialog__actions auth-dialog__actions--single">
            <app-button primary width="100%" (buttonClick)="onConfirmClose()">Close</app-button>
        </div>
    </dialog>

</div>
